export enum MainNavTabType {
    HOME = 'HOME',
    TRANSACTIONS = 'TRANSACTIONS',
    SCAN_QR = 'SCAN QR',
    MY_CARDS = 'MY CARDS',
    PROFILE = 'PROFILE'
}
